// extracted by mini-css-extract-plugin
export default {"tag":"style_tag__4eocP","action":"style_action__YjlpG"};